<template>
  <div>
    <v-container v-if="questionInfo">
      <v-card-title> คำถาม </v-card-title>
      <v-form ref="form">
        <v-card
          class="d-flex align-end py-6 flex-column"
          outlined
          tile
          style="
            min-height: 30px;
            height: auto !important; /* for IE as it does not support min-height */
            height: 30px;
          "
        >
          <v-card class="pa-0 ma-0" width="100%" flat color="transparent">
            <v-container>
              <v-sheet ref="chatbox" color="transparent">
                <v-row
                  v-for="(message, index) in questionInfo.questions"
                  :key="index"
                >
                  <v-col cols="12" class="py-0">
                    <v-card
                      class="d-flex mb-2 align-center"
                      :class="[
                        message.type === 'image'
                          ? 'justify-center'
                          : 'justify-start',
                      ]"
                      flat
                      tile
                      color="transparent"
                    >
                      <div
                        v-if="message.type === 'image'"
                        class="d-flex pa-0 ma-0 my-2 align-center"
                      >
                        <v-card
                          color="transparent"
                          class="d-flex justify-center"
                          flat
                          tile
                        >
                          <img :src="message.payload.url" width="50%" />
                        </v-card>
                      </div>
                      <div
                        v-else-if="message.type === 'video'"
                        class="d-flex pa-0 ma-0 my-2 align-center"
                      >
                        <v-card
                          color="transparent"
                          class="d-flex justify-center"
                          flat
                          tile
                        >
                          <video
                            width="200"
                            controls
                            :src="message.payload.url"
                          >
                            Your browser does not support the video tag.
                          </video>
                        </v-card>
                      </div>
                      <div
                        v-else
                        class="d-flex pa-0 ma-0 align-center"
                        :style="{
                          'max-width': MobileSize ? '75%' : '60%',
                        }"
                      >
                        <v-card
                          class="rounded"
                          color="transparent"
                          flat
                          tile
                          :style="{
                            'white-space': 'pre-line',
                          }"
                        >
                          {{ message.payload.text }}
                        </v-card>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-container>
          </v-card>
        </v-card>
        <CheckboxGroup
          v-if="questionInfo.conditionType === 'multiselect'"
          :data="questionInfo"
          :min="questionInfo.conditionsAnswer.match[0].min"
          :max="questionInfo.conditionsAnswer.match[0].max"
          @Answer="setAnswer"
        />
        <v-card flat color="transparent">
          <v-card-actions>
            <v-btn color="#1184bd" dark @click="SendChoice"> ตกลง </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import CheckboxGroup from "../../components/FormUI/CheckboxGroup.vue";
export default {
  components: { CheckboxGroup },
  data() {
    return {
      e1: 1,
      questionInfo: null,
      min_selected: 1,
      max_selected: 1,
    };
  },
  created() {
    this.getQuestion();
  },
  methods: {
    getQuestion() {
      if (this.$route.query) {
        this.$store
          .dispatch("CheckboxGroup", this.$route.query)
          .then((questioninfo) => {
            if (Object.keys(questioninfo).length > 0) {
              this.$delete(
                questioninfo.conditionsAnswer.match,
                questioninfo.conditionsAnswer.match.findIndex(
                  (c) => c.score.operation === "!!"
                )
              );
              this.min_selected = questioninfo.conditionsAnswer.match[0].min;
              this.max_selected = questioninfo.conditionsAnswer.match[0].max;
              questioninfo.conditionsAnswer.match = [
                questioninfo.conditionsAnswer.match[0],
              ];
              this.questionInfo = questioninfo;
            }
          })
          .catch((err) => {
            console.log(err);
            Swal.fire({
              icon: "error",
              text: "ไม่สามารถดูได้ ",
              title: "",
            });
          });
      }
    },
    SendChoice() {
      if (this.$refs.form.validate()) {
        let data = {
          surveySession: this.$route.query.surveySession,
          surveyID: this.$route.query.surveyID,
          questionID: this.$route.query.questionID,
          answer: "",
          socialType: this.$route.query.socialType,
          socialID: this.$route.query.socialID,
          userID: this.$route.query.userID,
          username: "",
        };
        let selected = [];
        let ans = "";
        this.questionInfo.conditionsAnswer.match.map((c) => {
          c.choice.map((s) => {
            if (s.selected) {
              selected.push(s);
              if (s.description) {
                ans === ""
                  ? (ans += `${s.text}:${s.detail}`)
                  : (ans += `,${s.text}:${s.detail}`);
              } else {
                ans === "" ? (ans += `${s.text}`) : (ans += `,${s.text}`);
              }
            }
          });
        });
        data.answer = ans;
        if (selected.length < 1) {
          Swal.fire({
            icon: "warning",
            text: "กรุณาเลือกอย่างน้อย 1 ตัวเลือก",
            title: "",
          });
        } else if (
          this.min_selected === this.max_selected &&
          selected.length !== this.min_selected
        ) {
          Swal.fire({
            icon: "warning",
            text: `ต้องเลือกทั้งหมด ${this.min_selected} ตัวเลือก`,
            title: "",
          });
        } else if (
          this.min_selected === 1 &&
          selected.length > this.max_selected
        ) {
          Swal.fire({
            icon: "warning",
            text: `เลือกได้ไม่เกิน ${this.max_selected} ตัวเลือก`,
            title: "",
          });
        } else if (
          this.min_selected > selected.length ||
          this.max_selected < selected.length
        ) {
          Swal.fire({
            icon: "warning",
            text: `เลือกอย่างน้อย ${this.min_selected} แต่ไม่เกิน ${this.max_selected} ตัวเลือก`,
            title: "",
          });
        } else {
          this.$store
            .dispatch("SendChoice", data)
            .then((resp) => {
              if (resp.stage === "ended") {
                Swal.fire({
                  html:
                    "คำถามข้อนี้ถูกเลือกไปแล้ว ไม่สามารถเลือกใหม่ได้ กดปุ่มขวาบนเพื่อปิดหน้าเว็บ",
                  icon: "error",
                  showCancelButton: false,
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  allowEnterKey: false,
                  confirmButtonColor: "#0093cc",
                  confirmButtonText: "รับทราบ",
                });
              } else {
                if (this.$route.query.socialType === "ONECHAT") {
                  this.$axios.post(
                    "https://chat-api.one.th/message/api/v2/disable_webview",
                    {
                      user_id: this.$route.query.userID,
                      bot_id: this.$route.query.socialID,
                    },
                    {
                      headers: {
                        Authorization: "Bearer " + this.$route.query.token,
                      },
                    }
                  );
                } else if (this.$route.query.socialType === "FACEBOOK") {
                  Swal.fire({
                    html: "เลือกคำตอบเรียบร้อย กดปุ่มขวาบนเพื่อปิดหน้าเว็บ",
                    icon: "success",
                    showCancelButton: false,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    confirmButtonColor: "#0093cc",
                    confirmButtonText: "รับทราบ",
                  });
                }
              }
            })
            .catch((err) => {
              console.log(err);
              Swal.fire({
                icon: "error",
                text: "ไม่สามารถบันทึกได้",
                title: "",
              });
            });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
